import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button      from '@material-ui/core/Button'
import Card        from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
// import CardContent from '@material-ui/core/CardContent'
import CardHeader  from '@material-ui/core/CardHeader'

import { CoachingCertificate } from '../../api'

interface CoachingCertificateCardProps {
  onRemove: () => void
  coachingCertificate: CoachingCertificate
}

const CoachingCertificateCard: React.SFC<CoachingCertificateCardProps> = ({
  onRemove,
  coachingCertificate:
    {
      name,
      grade,
      hours,
    },
}) => {
  return (
    <Card>
      <CardHeader title={name} />
      <CardActions>
        <Button
          onClick={onRemove}
          variant={'raised'}
          color={'secondary'}
        >
          <FormattedMessage id={'buttonActions.remove'} />
        </Button>
      </CardActions>
    </Card>
  )
}

export default CoachingCertificateCard



// WEBPACK FOOTER //
// ./src/components/molecules/CoachingCertificateCard.tsx